<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="700">
      <v-card>
        <v-card-title class="custom-card-header">
          <span class="headline">
            Edit Staff
          </span>
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="toggle"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="First name"
                  v-model="user.firstName">
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Last name"
                  v-model="user.lastName"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Email"
                  v-model="user.email">
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Phone"
                  v-model="user.phoneNumber">
                </v-text-field>
              </v-col>

              <v-col cols="12">
                  <v-select
                      :items="roles"
                      item-text="name"
                      item-value="id"
                      standard
                      label="Role"
                      v-model="roleId"
                  ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <div v-if="disabled" class="text-center">
          Saving<br />
          <v-progress-circular
            indeterminate
            color="success"
            v-if="disabled"
          ></v-progress-circular>
        </div>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="accent" dark depressed block @click="updateUser" :disabled="disabled">Save</v-btn>
        </v-card-actions>
        <v-alert v-if="this.error != null" dismissible color="error" dark>
          <v-icon size="20" dark>warning</v-icon>{{this.error}}
        </v-alert>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    userDetails: {
      type: Object
    },
    userRole: {
      type: Object
    }
  },
  data () {
    return {
      user: {
        id: null,
        email: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
      },
      disabled: false,
      role: null,
      roleId: null
    }
  },
  methods: {
    ...mapActions({
      update: 'user/updateUser',
    }),
    async updateUser () {
        this.disabled = true
        this.user.role = this.roleId;
        await this.update(this.user)
        if (!this.error) {
            this.toggle()
        }
      this.disabled = false
    }
  },
  computed: {
    ...mapGetters({
      roles: 'role/roles',
      error: 'user/error'
    })
  },
  watch: {
        userDetails (details) {
            this.user.id = details.id
            this.user.email = details.email
            this.user.firstName = details.firstName
            this.user.lastName = details.lastName
            this.user.phoneNumber = details.phoneNumber
        },
        userRole (role) {
            this.roleId = role.roleId
        }
  }
}
</script>
<style scoped>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
</style>
